<template>
  <v-container fluid style="max-width: 1200px" class="public-home px-0">
    <!-- Snackbar for error messages -->
    <v-snackbar color="error" v-model="hasError" :timeout="5000" location="top">
      {{ errorMsg }}
    </v-snackbar>
    <event-dates :extra-filters="['eventId']">
      <template v-slot:list-item-descriptors="{ eventDate }">
        <div style="width: 90px; display: inline-block">
          <div v-if="eventDate.soldOut" class="text-grey">Sold Out!</div>
          <!--this is for issue #169 logic when we need to know the number of available seat all the time for the calculation-->
          <div
            v-else-if="
              eventDate.availableSeats &&
              eventDate.availableSeats <= 20 &&
              staticData.SHOW_REMAINING_SEATS
            "
            class="font-weight-bold"
          >
            <!-- For a series this count is the series-wide total (null only when a date is uncapped,
          which then falls through to "Available"); "across all dates" flags that it spans the run. -->
            Only {{ eventDate.availableSeats }} remaining{{
              eventDate.isSeries ? " across all dates" : ""
            }}!
          </div>
          <div v-else>Available</div>
        </div>
      </template>

      <template #actions="{ eventDate }">
        <event-date-share-btn :eventDate="eventDate" color="secondary" />
        <event-date-start-purchase-btn :eventDate="eventDate" color="secondary">
        </event-date-start-purchase-btn>
      </template>

      <!-- Grid Specific Slots -->
      <!--
        It would be nice to re-use some of the same slots and content, but this is a bit more straight
       forward to separate the two with different colors/etc for now.
      -->

      <template #grid-card-actions="{ eventDate }">
        <event-date-share-btn :eventDate="eventDate" color="accent" />
        <event-date-start-purchase-btn :eventDate="eventDate" color="accent">
        </event-date-start-purchase-btn>
      </template>
      <template #grid-card-back-actions="{ eventDate }">
        <event-date-share-btn :eventDate="eventDate" color="primary" />
        <event-date-start-purchase-btn :eventDate="eventDate" color="primary">
        </event-date-start-purchase-btn>
      </template>
      <template #grid-card-status="{ eventDate }">
        <div style="width: 90px; display: inline-block">
          <div v-if="eventDate.soldOut">Sold Out!</div>
          <!--this is for issue #169 logic when we need to know the number of available seat all the time for the calculation-->
          <div
            v-else-if="
              eventDate.availableSeats &&
              eventDate.availableSeats <= 20 &&
              staticData.SHOW_REMAINING_SEATS
            "
            class="font-weight-bold"
          >
            <!-- For a series this count is the series-wide total (null only when a date is uncapped,
          which then falls through to "Available"); "across all dates" flags that it spans the run. -->
            Only {{ eventDate.availableSeats }} remaining{{
              eventDate.isSeries ? " across all dates" : ""
            }}!
          </div>
          <div v-else class="font-weight-regular">Available</div>
        </div>
      </template>

      <!-- End Grid Specific Slots -->
    </event-dates>
  </v-container>
</template>

<script setup lang="ts">
import EventDates from "@common/components/event-dates.vue";
import EventDateShareBtn from "@common/event/event-date-share-btn.vue";
import EventDateStartPurchaseBtn from "@common/event/event-date-start-purchase-btn.vue";
import useStaticData from "@common/composables/useStaticData";
import { ProvideInjectConsts } from "@common/provideInjectConsts";

const hasError = ref(false);
const errorMsg = ref<string | null>(null);

function showErrorSnackBar(message: string) {
  hasError.value = true;
  errorMsg.value = message;
}

provide(ProvideInjectConsts.ShowErrorSnackBar, showErrorSnackBar);

const staticData = useStaticData();
if (staticData.META_PIXEL_ENABLED) {
  (window as any).fbq("trackCustom", "HomePage");
}
</script>

<style lang="scss">
.public-home {
  .header-pagination.c-list-pagination {
    > div:first-child {
      display: none;
    }

    .c-list-range-display--start::before {
      content: "Showing ";
    }

    @media screen and (min-width: 960px) {
      .c-list-range-display--total::after {
        content: " total events";
      }
    }
  }
}
</style>
